// extracted by mini-css-extract-plugin
export default {"bubble":"DialogBubble_bubble__Q1q1R"};